export const apiName: string = 'Seguradoras';
export const seguradorasRoute: string = 'seguradoras';
export const seguradorasStorage: string = 'seguradoras';
export const seguradorasModuleName: any = {plural: 'Seguradoras', single: 'Seguradora'};

export const seguradorasQuery: any = {
    "where":{
        "ativo":true,
        "nome":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"nome",
    "include":["pessoaJuridica"]
};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/shared/data.service.ts
 **/